import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconQr = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path d="M14.2857 4H15.4284V5.14274H14.2857V4Z" />
    <path d="M17.7142 4H18.8573V5.14274H17.7142V4Z" />
    <path d="M4 4V12.0001H12.0001V4H4ZM10.8571 10.8571H5.143V5.143H10.8571V10.8571Z" />
    <path d="M15.4282 5.14274H17.7141V6.28548H18.8568V7.42873H16.5713V6.28548H15.4282V5.14274Z" />
    <path d="M20.0002 4V12.0001H27.9999V4H20.0002ZM21.1432 10.8571V5.143H26.8573V10.8571H21.1432Z" />
    <path d="M6.28556 6.28548H9.71429V9.71421H6.28556V6.28548Z" />
    <path d="M13.1431 6.28548H14.2858V7.42873H15.4286V8.57147H17.7144V9.71421H18.8571V13.1429H17.7144V14.2857H18.8571V15.4284H16.5717V16.5715H15.4286V14.2857H16.5717V13.1429H15.4286V14.2857H14.2858V12H15.4286V9.71421H14.2858V8.57147H13.1431V6.28548Z" />
    <path d="M22.2854 6.28548H25.7141V9.71421H22.2854V6.28548Z" />
    <path d="M13.1431 10.8571H14.2862V12.0002H13.1431V10.8571Z" />
    <path d="M7.42856 13.1431H9.71404V14.2858H10.8568V15.4286H11.9999V16.5717H10.8568V17.7144H11.9999V16.5717H13.1428V17.7144H14.2855V18.8571H16.5713V17.7144H17.7141V20.0001H16.5713V21.1431H13.1428V18.8571H7.42864V17.7144H8.57138V16.5717H9.71412V15.4286H8.57138V14.2858H7.42864L7.42856 13.1431Z" />
    <path d="M10.8571 13.1431H13.1426V14.2862H10.8571V13.1431Z" />
    <path d="M23.4284 13.1431H25.7143V14.2858H24.5716V16.5717H23.4284V15.4286H22.2853V16.5717H23.4284V17.7144H25.7143V16.5717H26.8567V17.7144H27.9998V18.8571H26.8567V20.0001H25.7143V21.1431H27.9998V23.4286H26.8567V22.2855H25.7143V23.4286H24.5716V21.1431H23.4284V20.0001H24.5716V18.8571H21.1429V20.0001H18.8569V16.5717H21.1429V15.4286H20.0001V14.2858H23.4284V13.1431Z" />
    <path d="M4 14.2857H6.28548V15.4284H8.57147V16.5715H6.28548V17.7142H5.14274V15.4284H4V14.2857Z" />
    <path d="M13.1431 14.2857H14.2862V16.5712H13.1431V14.2857Z" />
    <path d="M26.8569 14.2857H28V16.5712H26.8569V14.2857Z" />
    <path d="M4 17.7142H5.14274V18.8573H4V17.7142Z" />
    <path d="M4 19.9998V27.9999H12.0001V19.9998H4ZM10.8571 26.8569H5.143V21.1432H10.8571V26.8569Z" />
    <path d="M17.7142 21.1428H18.8573V22.2855H17.7142V21.1428Z" />
    <path d="M6.28556 22.2854H9.71429V25.7141H6.28556V22.2854Z" />
    <path d="M13.1431 22.2854H14.2858V23.4284H15.4286V24.5712H16.5717V25.7144H17.7144V26.8568H15.4286V27.9999H14.2858V24.5712H13.1431V22.2854Z" />
    <path d="M15.4282 22.2854H17.7137V23.4284H15.4282V22.2854Z" />
    <path d="M20.0002 22.2854H21.143V23.4284H22.2854V22.2854H23.4284V24.5712H24.5717V26.8568H23.4284V25.7144H22.2854V26.8568H23.4284V27.9999H21.143V24.5712H20.0002V22.2854Z" />
    <path d="M25.7143 24.5714H27.9998V26.8568H25.7143V24.5714Z" />
    <path d="M18.8568 25.7143H19.9999V26.8571H18.8568V25.7143Z" />
    <path d="M17.7142 26.8569H18.8573V28H17.7142V26.8569Z" />
    <path d="M24.5718 26.8569H25.7145V28H24.5718V26.8569Z" />
  </svg>
);

export default IconQr;
